(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 8318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(4178);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _supabase_supabase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2877);

var url = "https://guolblvfzlckempvivya.supabase.co";
var key = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd1b2xibHZmemxja2VtcHZpdnlhIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTk5MjYwOTEsImV4cCI6MTk3NTUwMjA5MX0.iSU61kczZknJtdY30xdV_TSNYWPyG0rblsMxmxH427c";
if (!url || !key) {
    throw new Error("Missing environment variables to connect to Supabase");
}
/* harmony default export */ __webpack_exports__["Z"] = ((0,_supabase_supabase_js__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .eI)(url, key, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
    }
}));


/***/ }),

/***/ 4178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_Acrylic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9410);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var sections_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5325);




var AboutPage = function(param) {
    var changelog = param.changelog;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full max-w-6xl mx-auto py-2 px-1 flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_Header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex flex-col sm:flex-row pt-8 sm:justify-between items-center sm:items-start gap-4 mb-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Acrylic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "w-96 p-3 rounded flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-xl font-medium",
                                children: "About"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "leading-snug",
                                children: [
                                    "GradientHub is a place to create and share CSS gradients. It is a project by",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "https://thomaseckert.dev",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "underline underline-offset-2 cursor-pointer",
                                            children: "Thomas Eckert"
                                        })
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    "The project is under active development. If you have feedback, please submit it",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/feedback",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "underline cursor-pointer",
                                            children: "here"
                                        })
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    changelog && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Acrylic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        className: "w-96 p-3 rounded flex flex-col gap-4 flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                            dangerouslySetInnerHTML: {
                                __html: changelog
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed -top-[150vh] -left-[100vw] -z-10 h-[200vh] w-[200vw] -rotate-12 overflow-clip",
                style: {
                    background: "radial-gradient(circle, rgba(2,0,36,1) 0%, rgba(9,121,97,0.7044123960344979) 23%, rgba(0,212,255,1) 100%)"
                }
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (AboutPage);


/***/ }),

/***/ 5325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./user/useUser.ts + 2 modules
var useUser = __webpack_require__(3262);
// EXTERNAL MODULE: ./client.ts
var client = __webpack_require__(2102);
;// CONCATENATED MODULE: ./sections/Header/User.tsx







var User = function() {
    var ref = (0,useUser/* default */.Z)(), user = ref.data;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var signIn = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return client/* default.auth.signInWithOAuth */.Z.auth.signInWithOAuth({
                            provider: "github"
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function signIn() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-sm font-medium flex items-center justify-center pb-0.5",
        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/profiles/".concat(user.id),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cursor-pointer transition hover:underline",
                children: (user === null || user === void 0 ? void 0 : user.name) || ""
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: signIn,
            className: "transition hover:underline",
            disabled: loading,
            children: "Sign in with GitHub"
        })
    });
};
/* harmony default export */ var Header_User = (User);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/MenuIcon.js
var MenuIcon = __webpack_require__(93);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 21 modules
var menu = __webpack_require__(1326);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Acrylic.tsx
var Acrylic = __webpack_require__(9410);
;// CONCATENATED MODULE: ./sections/Header/Navigation.tsx












var Link = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var href = props.href, children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "href",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, rest), {
            children: children
        }))
    });
});
var Navigation = function() {
    var ref = (0,useUser/* default */.Z)(), user = ref.data;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Button */.v.Button, {
                    children: function(param) {
                        var open = param.open;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Acrylic/* default */.Z, {
                            className: [
                                "flex items-center justify-center rounded-full px-1.5 py-1 text-slate-900 transition hover:bg-slate-900 hover:text-white",
                                open && "bg-slate-900 text-white", 
                            ].join(" "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                className: "h-4 aspect-square"
                            })
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
                    className: "origin-top-right right-0 mt-1 absolute items-end rounded shadow text-sm font-medium",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Acrylic/* default */.Z, {
                        className: "rounded flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                children: function(param) {
                                    var active = param.active;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                        className: [
                                            "px-2 py-0.5 rounded-t",
                                            active && "bg-slate-900 text-white", 
                                        ].join(" "),
                                        href: "/feedback",
                                        children: "Feedback"
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                children: function(param) {
                                    var active = param.active;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                        className: [
                                            "px-2 w-full text-right py-0.5",
                                            active && "bg-slate-900 text-white",
                                            !user && "rounded-b", 
                                        ].join(" "),
                                        href: "/about",
                                        children: "About"
                                    });
                                }
                            }),
                            user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: function(param) {
                                            var active = param.active;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                className: [
                                                    "px-2 w-full text-right py-0.5",
                                                    active && "bg-slate-900 text-white", 
                                                ].join(" "),
                                                href: "/create",
                                                children: "Create"
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: function(param) {
                                            var active = param.active;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                                className: [
                                                    "px-2 w-full text-right py-0.5",
                                                    active && "bg-slate-900 text-white", 
                                                ].join(" "),
                                                href: "/profiles/".concat(user.id),
                                                children: "Profile"
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
                                        children: function(param) {
                                            var active = param.active;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: [
                                                    "px-2 w-full text-right py-0.5",
                                                    active && "bg-slate-900 text-white rounded-b", 
                                                ].join(" "),
                                                onClick: function() {
                                                    client/* default.auth.signOut */.Z.auth.signOut();
                                                    router.reload();
                                                },
                                                children: "Sign out"
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Navigation = (Navigation);

// EXTERNAL MODULE: ./useScrollPosition.ts
var useScrollPosition = __webpack_require__(887);
;// CONCATENATED MODULE: ./sections/Header/Header.tsx





var Header = function() {
    var scrollPosition = (0,useScrollPosition/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: [
            "z-50 sticky top-2 flex flex-row justify-between items-center transition-all",
            scrollPosition > 20 ? "px-1" : "px-0", 
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "font-medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: "GradientHub"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "flex flex-row items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_User, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Navigation, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./sections/Header/index.ts

/* harmony default export */ var sections_Header = (Header_Header);


/***/ }),

/***/ 887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useScrollPosition = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), scrollPosition = ref[0], setScrollPosition = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var updatePosition = function() {
            setScrollPosition(window.pageYOffset);
        };
        window.addEventListener("scroll", updatePosition);
        updatePosition();
        return function() {
            return window.removeEventListener("scroll", updatePosition);
        };
    }, []);
    return scrollPosition;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScrollPosition);


/***/ }),

/***/ 3262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ user_useUser; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(3471);
// EXTERNAL MODULE: ./client.ts
var client = __webpack_require__(2102);
;// CONCATENATED MODULE: ./user/fetchUser.ts



var fetchUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, _data, authenticatedUser, ref1, user, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return client/* default.auth.getUser */.Z.auth.getUser();
                case 2:
                    ref = _ctx.sent;
                    _data = ref.data;
                    authenticatedUser = _data.user;
                    if (authenticatedUser) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error();
                case 7:
                    _ctx.next = 9;
                    return client/* default.from */.Z.from("profiles").select("*, likes (*)").eq("id", authenticatedUser.id).single();
                case 9:
                    ref1 = _ctx.sent;
                    user = ref1.data;
                    error = ref1.error;
                    if (!error) {
                        _ctx.next = 14;
                        break;
                    }
                    throw error;
                case 14:
                    if (user) {
                        _ctx.next = 16;
                        break;
                    }
                    throw new Error();
                case 16:
                    return _ctx.abrupt("return", user);
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchUser() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var user_fetchUser = (fetchUser);

;// CONCATENATED MODULE: ./user/upsertUser.ts



var upsertUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, _data, authenticatedUser, githubMetadata, updates, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return client/* default.auth.getUser */.Z.auth.getUser();
                case 2:
                    ref = _ctx.sent;
                    _data = ref.data;
                    authenticatedUser = _data.user;
                    if (authenticatedUser) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error();
                case 7:
                    githubMetadata = authenticatedUser.user_metadata;
                    updates = {
                        id: authenticatedUser.id,
                        name: githubMetadata.name,
                        githubUserName: githubMetadata.user_name,
                        avatar: githubMetadata.avatar_url
                    };
                    _ctx.next = 11;
                    return client/* default.from */.Z.from("profiles").upsert(updates);
                case 11:
                    error = _ctx.sent.error;
                    if (!error) {
                        _ctx.next = 14;
                        break;
                    }
                    throw error;
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function upsertUser() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var user_upsertUser = (upsertUser);

;// CONCATENATED MODULE: ./user/useUser.ts





var useUser = function() {
    return (0,index_production.useQuery)([
        "current-user"
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var user;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return user_upsertUser();
                case 2:
                    _ctx.next = 4;
                    return user_fetchUser();
                case 4:
                    user = _ctx.sent;
                    return _ctx.abrupt("return", user);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
};
/* harmony default export */ var user_useUser = (useUser);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [225,774,888,179], function() { return __webpack_exec__(8318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);